import { V3StaticLayout } from "layouts/v3Static"
import { MarketSectorsListPage } from "modules/market-sectors/ListPage/MarketSectorsListPage"
import { type GetStaticProps } from "next"

const MarketsIndexPage = () => {
  return <MarketSectorsListPage />
}

MarketsIndexPage.getLayout = V3StaticLayout

export default MarketsIndexPage

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {},
  }
}
